module.exports = __webpack_public_path__ + "static/AngelaHe9-56a4b415d62bfb282d7cd1604e7d87e1.webp";